import PropTypes from 'prop-types';
import React from 'react';

import styles from './white-list.css';

const WhiteListButton = props => (
    <div
        className={styles.whiteListButtonBox}
        onClick={props.onClick}
    >
        <div className={styles.whiteListButton}>
            {props.text}
        </div>
    </div>
);

WhiteListButton.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.strgin
};

export default WhiteListButton;
